var EHDI = EHDI || Object.create(null);
var UTILS = UTILS || Object.create(null);
var POOLS = POOLS || Object.create(null);

EHDI.components = EHDI.components || Object.create(null);

EHDI.components.GlowEffect = function(size) {     
    EHDI.aka.Container.call(this);

    this.active = false;

    this.visual = new EHDI.aka.Sprite(EHDI.Assets.images["fx_firsttimeplay_glow"]);
    this.visual.anchor.set(0.5, 0.5);
    this.scale.x = size / this.visual.width;
    this.scale.y = size / this.visual.height;
    this.addChild(this.visual);

    this.resetRotation = function()
    {
        this.rotation = 0;

        if(this.active)
            this.timeLineStart();
    }

    this.timeLineStart = function()
    {
        if(!this.tl)
            this.tl = new TimelineMax(); 

        this.tl.to(this, 10, {rotation: 360 *(Math.PI / 180 ), repeat: -1, ease:Power0.easeNone});
        this.tl.play();

    }

    this.timeLineKill = function()
    {
        if(!this.tl)
        {
            this.tl.kill();
            this.tl = null;
        }

    }
    
    this.timeLinePause = function()
    {
        if(!this.active)
            return;
        this.tl.pause();

    }

    this.timeLineResume = function()
    {        
        if(!this.active)
            return;
        this.tl.play();
    }

    this.appear = function(score)
    {
        if(this.active)
            return;

        this.active = true;
        this.resetRotation();

    }

    this.disappear = function()
    {
        if(!this.active)
            return;

        this.active = false;

        if(this.tl)
            this.tl.stop();

    }


    this.update = function (delta)
    {
        if(!this.active)
            return false;

        this.rotation += delta * 0.1;


        return false;
    }
    
    this.dispose = function()
    {
        this.active = null;
        
        if(this.visual != null)
        {
            this.removeChild(this.visual);
            this.visual.destroy({children: true});
        }
        delete this.visual;

        this.timeLineKill();
    }

}
EHDI.components.GlowEffect.prototype = Object.create(EHDI.aka.Container.prototype);